import { Button, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import { formDataValidate } from '../../../../../utils/formUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  addInRoomDiningAllergen,
  editInRoomDiningAllergen,
} from '../../../../../utils/ServicesAPIUtils';
import { fetchAllInRoomDining } from '../../../servicesSlice';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import Tooltip from '@mui/material/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import InfoIcon from '@mui/icons-material/Info';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const AllergensCreate = (props) => {
  const { toggleDrawer, allergen, hotelId, restaurantId, showLoader = () => {} } = props;
  const [loading, setLoading] = useState(false);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const dispatch = useDispatch();
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
    status: {
      value: false,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    if (allergen) {
      const currFields = { ...formData };
      currFields.code.value = allergen.code;
      currFields.name.value = allergen.name;
      currFields.customAttributes.value = allergen.customAttributes || [];
      currFields.status.value = allergen.status;

      setFormData(currFields);
    }
  }, [allergen]);

  const CustomToolTip = withStyles({
    tooltip: {
      color: 'white',
      backgroundColor: 'black',
    },
  })(Tooltip);

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (hotelId) {
      if (validate()) {
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        try {
          dispatch(stepUpLoaderCount());
          toggleDrawer('', false, '');
          setLoading(true);
          const payload = {
            name: formData.name.value,
            code: formData.code.value,
            customAttributes: formData.customAttributes.value,
            status: formData.status.value,
            hotelId: hotelId,
            restaurantId: restaurantId,
          };
          if (allergen) {
            payload.id = allergen.id;
            await editInRoomDiningAllergen(payload, language);
            notificationManager('success', 'Allergen updated successfully');
          } else {
            await addInRoomDiningAllergen(payload, language);
            notificationManager('success', 'Allergen created successfully');
          }
          dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        } catch (error) {
          if (error.graphQLErrors) {
            notificationManager('danger', error?.graphQLErrors?.[0]?.message);
          } else {
            allergen
              ? notificationManager('danger', 'Failed to update Allergen')
              : notificationManager('danger', 'Failed to create Allergen');
          }
        } finally {
          dispatch(stepDownLoaderCount());
        }
        setLoading(false);
      }
    }
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  useEffect(() => {
    const isValid = formDataValidate(formData, false);
    setIsTabInValid(!isValid);
  }, [formData]);

  return (
    <form onSubmit={handleSubmit} className='category-create' noValidate>
      <div className='container pt-4 d-flex align-items-end flex-column '>
        <div className='row px-3 w-100 mt-4'>
          <div className='col-md-6'>
            <span className='page-title'>{allergen ? 'Edit Allergen' : 'Add Allergen'}</span>
          </div>
          <div className='col-md-6 d-flex justify-content-end'>
            <IconButton aria-label='delete' onClick={(e) => onCancel(e)}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
          <div className='row px-3 w-100 mt-4'>
            <div className='col-md-6'>
              <span className='page-title-secondary'>Details</span>
            </div>
          </div>
          <div className='row px-3 w-100 d-flex mt-3'>
            <div className='row mb-2'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData.name}
                  handleInputChange={(e) => {
                    setFormData({ name: e });
                  }}
                  maxLength={100}
                  endAdornment={true}
                  characterCount={true}
                  multiline={true}
                />
              </div>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData.code}
                  handleInputChange={(e) => {
                    setFormData({ code: e });
                  }}
                  maxLength={8}
                  endAdornment={true}
                  characterCount={true}
                />
              </div>
            </div>
            <div className='row px-3 w-100 d-flex'>
              <div className='col-md-3 mb-3'>
                <div className='d-flex align-items-center'>
                <CustomCheckbox
                  item={formData.status}
                  handleInputChange={(e) => {
                    setFormData({ status: e });
                  }}
                  color='primary'
                />
                <CustomToolTip
                  title='Deactivating this, hides it from Guest app'
                  placement='right-end'
                >
                  <InfoIcon style={{ marginLeft: 8 }} />
                </CustomToolTip>
                </div>
              </div>
            </div>
            <KeyValuePairList
              item={formData.customAttributes}
              onListChange={(e) => {
                setFormData({ customAttributes: e });
              }}
            />
          </div>
        </div>
        <div className='row mx-2 mt-auto px-4 w-100 pb-5'>
          <div className='col-md-12 d-flex justify-content-start'>
            <Button
              variant='contained'
              type='submit'
              color='primary'
              className='me-3'
              size='large'
              disabled={isTabInValid || loading}
            >
              {allergen ? 'Update' : 'Add'}
            </Button>
            <Button
              disabled={loading}
              variant='outlined'
              type='button'
              color='secondary'
              size='large'
              onClick={(e) => onCancel(e)}
            >
              Cancel
            </Button>
          </div>
          {loading && <div className='pt-4 col-md-12'>{<LinearProgressBar />}</div>}
        </div>
      </div>
    </form>
  );
};

export default AllergensCreate;
